module.exports = __webpack_public_path__ + "media/auto_history/pierwszy_wlasciciel-3731faa3.svg";